export const defaultOsObjectState = () => ({
  id: undefined,
  description: null,
  active: false,
});

const defaultOSObjectsModuleState = () => ({
  summaryOsObjects: [],
  paginationOsObjects: {
    perPage: 15,
    currentPage: 1,
  },
});

const initialState = {
  ...defaultOSObjectsModuleState(),
  osObject: {
    ...defaultOsObjectState(),
  },
  tableKey: 0,
};

export default {
  ...initialState,
};
